import React, { useEffect, useState } from 'react'

import { Col, Row, Skeleton } from 'antd'

import {
  DayRange,
  LoadTimeByPage,
  UniquePageLoad,
  getAverageNDaysReport,
  getUniquePageLoads,
} from 'core/application/csiDashboard/performanceTracking'

import Card from 'common/components/dataDisplay/Card'

import { queryRequest } from 'common/RequestUtils'

import Last14DaysReport from './common/components/Last14DaysReport'
import Last24Hours from './common/components/Last24HoursReport'
import UniquePageLoadsComponent from './common/components/UniquePageLoads'

export const PERFORMANCE_TRACKING_PATH = 'performance-tracking'

const PerformanceTracking: React.FC = () => {
  const [loadingLast24hReport, setLoadingLast24hReport] = useState<boolean>(false)
  const [last24hAverageReport, setLast24hAverageRepost] = useState<LoadTimeByPage[]>([])
  const [loadingUniquePageLoads, setLoaingUniquePageLoads] = useState<boolean>(false)
  const [uniquePageLoads, setUniquePageLoads] = useState<UniquePageLoad[]>([])
  const [loadingLast14DaysReport, setLoadingLast14DaysReport] = useState<boolean>(false)
  const [last14DaysReport, setLast14DaysReport] = useState<LoadTimeByPage[]>([])

  useEffect(() => {
    fetchAverage24hReport()
    fetchUniquePageLoads()
    fetchAverage14DaysReport()
  }, [])

  const fetchAverage24hReport = async () => {
    setLoadingLast24hReport(true)
    const result = await queryRequest(() => getAverageNDaysReport(DayRange.LastDay))
    setLast24hAverageRepost(result)
    setLoadingLast24hReport(false)
  }

  const fetchAverage14DaysReport = async () => {
    setLoadingLast14DaysReport(true)
    const result = await queryRequest(() => getAverageNDaysReport(DayRange.Last14Days))
    setLast14DaysReport(result)
    setLoadingLast14DaysReport(false)
  }

  const fetchUniquePageLoads = async () => {
    setLoaingUniquePageLoads(true)
    const result = await queryRequest(() => getUniquePageLoads())
    setUniquePageLoads(result)
    setLoaingUniquePageLoads(false)
  }

  return (
    <>
      {last24hAverageReport && (
        <Skeleton active loading={loadingLast24hReport}>
          <Row>
            <Last24Hours last24HoursReport={last24hAverageReport} />
          </Row>
        </Skeleton>
      )}

      <Card title={'Unique page loads - Last 24h'} className="mt-16">
        <Row align="middle">
          <Skeleton active loading={loadingUniquePageLoads}>
            <UniquePageLoadsComponent uniquePageLoads={uniquePageLoads} />
          </Skeleton>
        </Row>
      </Card>

      <Row justify="space-between" align="middle">
        <Skeleton active loading={loadingLast14DaysReport}>
          <Col span={24}>
            <Last14DaysReport last14DaysReport={last14DaysReport} />
          </Col>
        </Skeleton>
      </Row>
    </>
  )
}

export default PerformanceTracking
